// extracted by mini-css-extract-plugin
export default {"page-loader":"PageLoader_page-loader__W7G8j"};